(function () {
  var STORAGE_KEY = 'hdt-theme-mode';
  var root = document.documentElement;

  function getMode() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light';
    } catch (error) {
      return root.classList.contains('hdt-theme-dark') ? 'dark' : 'light';
    }
  }

  function saveMode(mode) {
    try {
      window.localStorage.setItem(STORAGE_KEY, mode);
    } catch (error) {
      // Storage can be blocked in private browsing; class state still works.
    }
  }

  function applyMode(mode) {
    var isDark = mode === 'dark';
    root.classList.toggle('hdt-theme-dark', isDark);
    root.dataset.hdtThemeMode = mode;

    document.querySelectorAll('[data-hdt-theme-toggle]').forEach(function (toggle) {
      toggle.setAttribute('aria-pressed', isDark ? 'true' : 'false');
      toggle.setAttribute('aria-label', isDark ? 'Switch to light mode' : 'Switch to dark mode');
      toggle.title = isDark ? 'Switch to light mode' : 'Switch to dark mode';
    });
  }

  function bindToggles() {
    applyMode(getMode());

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-hdt-theme-toggle]');
      if (!toggle) return;

      var nextMode = root.classList.contains('hdt-theme-dark') ? 'light' : 'dark';
      saveMode(nextMode);
      applyMode(nextMode);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindToggles);
  } else {
    bindToggles();
  }
})();
